import React, { createContext, useContext } from "react";

// 個別グラフ表示（EachConditionChart）配下の全グラフで共有する「x 軸固定」状態。
// syncMethod="value" のため、固定キーは index 値そのもの（共有 x 値）で保持する。
export interface ChartLockValue {
    // 固定中の共有 x 値。null = 非固定（従来どおりホバー追従）。
    lockedValue: number | null;
    setLockedValue: (v: number | null) => void;
    // 直近ホバーの x 値。ツールバートグルで「現在位置に固定」するために参照する（再レンダ不要なので ref）。
    lastHoveredValueRef: React.MutableRefObject<number | null>;
}

const ChartLockContext = createContext<ChartLockValue | null>(null);

export const ChartLockProvider = ChartLockContext.Provider;

// provider 不在でも安全に動くよう、既定は「常に非固定」を返す（既存挙動と同一）。
const NOOP_REF: React.MutableRefObject<number | null> = { current: null };
const DEFAULT_LOCK: ChartLockValue = {
    lockedValue: null,
    setLockedValue: () => {},
    lastHoveredValueRef: NOOP_REF,
};

export const useChartLock = (): ChartLockValue => useContext(ChartLockContext) ?? DEFAULT_LOCK;
